import axios from "axios";
import baseURL from "../../shared/utils/constant";

import { getStorageInfo } from "../../shared/utils/methods";

const axiosInstance = (token) => {
  return axios.create({
    baseURL,
    timeout: 36000,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getDashboardDataAPI = async (userId) => {
  const userData = getStorageInfo();
  return axiosInstance(userData.token)
    .get(`${baseURL}/dashboard/${userId}`)
    .then((res) => res.data);
};

export const getDashboardLeadsAPI = async (userId) => {
  const userData = getStorageInfo();
  return axiosInstance(userData.token)
    .get(`${baseURL}/dashboard/lead/${userId}`)
    .then((res) => res.data);
};
